import React from 'react'
import plowing from '../images/ideal-plow.png'

function Plowing() {
  return (
    <>
        <h2>Plowing</h2>
        <section id= "plowing-service" >
            <p id= "plowing-description" className= "service-description">
            When winter brings snow to your doorstep, Ideal Plowing is here to ensure a smooth and hassle-free experience. For plowing services or inquiries, drop us an email at <a href="mailto:IdealDisposalServices@gmail.com">IdealDisposalServices@gmail.com</a> or give us a call. Our dedicated team offers prompt and reliable snow plowing tailored to your property's needs. With Ideal Plowing, you can trust us to keep your driveways clear during the winter months. Stay warm indoors while we handle the snow removal for you!
           </p>
            <div id= "plowing-image"><img src={plowing} alt="Ideal Disposal Plow" /></div>
        </section>
    </>
    
  )
}

export default Plowing;